function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_10867_68265)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.8107 4.65234L1.69711 4.65234C1.31427 4.65234 1.00391 4.9627 1.00391 5.34554L1.00391 17.0443C1.00391 17.4271 1.31427 17.7375 1.69711 17.7375L17.8107 17.7375C18.1935 17.7375 18.5039 17.4271 18.5039 17.0443L18.5039 5.34554C18.5039 4.9627 18.1935 4.65234 17.8107 4.65234Z",
  fill: "#4989F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.6064 4.54687L1.87805 4.54688C1.39077 4.54688 1.01172 8.31772 1.01172 8.80472L9.62499 17.7303L17.6064 17.7303C17.8412 17.7297 18.0661 17.6361 18.2321 17.4701C18.3981 17.3041 18.4916 17.0791 18.4922 16.8444L18.4922 5.43262C18.4916 5.1979 18.398 4.97299 18.232 4.80703C18.066 4.64106 17.8411 4.54753 17.6064 4.54687Z",
  fill: "url(#paint0_linear_10867_68265)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 6.8396L9.99998 6.8396V0.277344L5.74874 0.277344L5 6.8396Z",
  fill: "#3C4BA6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 6.8396L10 6.8396L10 0.277344L14.2518 0.277344L15 6.8396ZM18.5041 1.52154L18.5102 1.54392C18.5089 1.53581 18.5059 1.5285 18.5041 1.52154Z",
  fill: "#7BABF7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.5085 1.54321L18.5023 1.52128C18.4254 1.16896 18.2303 0.853521 17.9495 0.627273C17.6686 0.401024 17.3189 0.277557 16.9583 0.277344L14.25 0.277344L14.9981 6.83978L19.9981 6.83978L18.5085 1.54321Z",
  fill: "#3F51B5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.4949 1.51953L1.48828 1.54328C1.48989 1.53467 1.49311 1.52691 1.4949 1.51953Z",
  fill: "#7BABF7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.48609 1.53975L1.49233 1.51737C1.56928 1.16507 1.76433 0.849641 2.04514 0.623394C2.32595 0.397148 2.67565 0.273671 3.03627 0.273437L5.74535 0.273437L4.99652 6.83587L-0.00390625 6.83587L1.48609 1.53975Z",
  fill: "#7BABF7"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.00884 6.83594C5.00884 8.21591 3.89023 9.3345 2.51024 9.3345C1.13024 9.3345 0.0117188 8.21591 0.0117188 6.83594L5.00884 6.83594Z",
  fill: "#709BE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.005 6.83594C10.005 8.21591 8.88632 9.3345 7.50642 9.3345C6.12652 9.3345 5.00781 8.21591 5.00781 6.83594L10.005 6.83594Z",
  fill: "#3C4BA6"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.0049 6.83594C15.0049 8.21591 13.8863 9.3345 12.5063 9.3345C11.1263 9.3345 10.0078 8.21591 10.0078 6.83594L15.0049 6.83594Z",
  fill: "#709BE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.9971 6.83594C19.9971 8.21591 18.8785 9.3345 17.4986 9.3345C16.1187 9.3345 15 8.21591 15 6.83594L19.9971 6.83594Z",
  fill: "#3C4BA6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.5012 13.6063C17.4923 13.4874 17.4776 13.3787 17.4566 13.24H14.7312C14.7312 13.6212 14.7312 14.0372 14.7297 14.4185H16.3087C16.2751 14.5963 16.2068 14.7657 16.1076 14.9169C16.0084 15.0682 15.8803 15.1983 15.7306 15.2999C15.7306 15.2999 15.7306 15.2933 15.7296 15.2931C15.5363 15.4201 15.3186 15.5052 15.0905 15.5428C14.8617 15.5846 14.6272 15.5836 14.3989 15.5398C14.167 15.4918 13.9475 15.3966 13.754 15.2602C13.4683 15.0577 13.2479 14.7761 13.12 14.4501C13.1102 14.4248 13.1012 14.3992 13.092 14.3733V14.3704L13.0944 14.3685C12.97 14.0039 12.9695 13.6083 13.0931 13.2433C13.18 12.9875 13.3232 12.7543 13.512 12.561C13.7295 12.336 14.0047 12.1753 14.3075 12.0965C14.6103 12.0176 14.929 12.0237 15.2286 12.114C15.4627 12.1858 15.6767 12.3118 15.8531 12.4817L16.3859 11.9489C16.4798 11.8541 16.5774 11.7622 16.6678 11.6637C16.3977 11.4117 16.0807 11.2154 15.7347 11.0858C15.1052 10.8576 14.4165 10.8516 13.783 11.0687C13.761 11.0763 13.7391 11.0841 13.7173 11.0923C13.0339 11.3492 12.4717 11.853 12.1417 12.5042C12.0252 12.7347 11.9403 12.9799 11.8895 13.2332C11.5877 14.7326 12.5026 16.2086 13.9799 16.6053C14.4628 16.7346 14.9761 16.7314 15.4628 16.6209C15.905 16.5213 16.314 16.3091 16.65 16.0048C17.0004 15.6824 17.2516 15.2529 17.3832 14.7968C17.4932 14.4102 17.533 14.007 17.5008 13.6063H17.5012Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_10867_68265",
  x1: 0.938465,
  y1: 11.0457,
  x2: 18.4698,
  y2: 11.0457,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.03,
  stopColor: "#4079D8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4989F5"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_10867_68265"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 17.4563,
  fill: "white",
  transform: "translate(0 0.273438)"
})));

var SvgGoogleBusiness = function SvgGoogleBusiness(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleBusiness, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google-business.22d39e72.svg";
export { ForwardRef as ReactComponent };